
export default {
	currentUser: { },
	productOptionTypes: {},
	productOptionTypeIds: [],
}